import InspectionsPageLink from './InspectionsPageLink';

export default InspectionsPageLink;
